import React from 'react';
import './MindquestRedirect.scss';
import { Button } from "cf-neo-ui";
import { withRouter, Link } from "react-router-dom";
 
function MindquestRedirect() {
  const handleRedirect = () => {
    window.location.href = "https://mindquest.io";
  };
  return (
    <div className="app-container">
      {/* Sidebar fixe à gauche */}
      <div className="sidebar">
        <img
          src="/assets/svg/sidebarredirection.svg"
          alt="Background sidebar"
        />
      </div>
 
      <div className="main-content">
        {/* En-tête */}
        <div className="header-container">
          <img
            src="/assets/images/logo_mindquest.webp"
            alt="Logo Mindquest"
          />
        </div>
 
        {/* Contenu central */}
        <div className="main-content-body">
        <p className="transition-text">
      Club Freelance est devenu Mindquest, retrouvez votre service sur
      <br />
        <span
          onClick={() => window.location.href = "https://mindquest.io"}
          style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
      >
          https://mindquest.io
        </span>
        </p>

 
          <img
            src="/assets/images/redirectiongoback.png"
            alt="Illustration transition"
            className="transition-image"
          />
 
          <Button
            variant="primary"
            size="lg"
            onClick={handleRedirect}
            className="mindquest-button"
          >
            Continuer sur le site Mindquest
          </Button>
        </div>
 
        {/* Pied de page */}
        <p className="footer-text">
          Service de recrutement spécialisé en informatique et en finance en Freelance et en CDI
        </p>
      </div>
    </div>
  );
}
 
MindquestRedirect.propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func
    }).isRequired
};

export default withRouter(MindquestRedirect);